// @ts-nocheck
import clsx from 'clsx'
import { FC } from 'react'
import { Row } from 'react-table'
import Swal from 'sweetalert2'
import { ContractTerm } from '../../../core/_models'
import { useNavigate } from 'react-router-dom'
import useAuthorization from '../../../../../hooks/useAuthorization'
import { TooltipWrapper } from '../../../../../components/Tooltip'
import { deleteContractTerm } from '../../../core/_request'
import { useQueryResponse } from '../../../core/QueryResponseProvider'

type Props = {
  row: Row<ContractTerm>
}

const CustomRow: FC<Props> = ({ row }) => {
  const id = String(row.original.id) as string

  const navigate = useNavigate()
  const { refetch } = useQueryResponse()
  const isAuthorized = useAuthorization('admin.contract_terms')
  const handleToEdit = () => navigate(`/admin/contract-terms/${id}/edit`)

  const handleToDelete = async () => {
    const result = await Swal.fire({
      title: `Deseja excluir o termo "${row.original.name}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
    })

    if (!result.isConfirmed) return

    try {
      await deleteContractTerm(id)
      await Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Termo excluído com sucesso',
        showConfirmButton: false,
        timer: 1500,
      })
      refetch()
    } catch (error: any) {
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.message,
      })
    }
  }

  return (
    <tr {...row.getRowProps()}>
      {row.cells.map((cell) => {
        return (
          <td
            {...cell.getCellProps()}
            className={clsx({ 'text-end min-w-100px': cell.column.id === 'actions' })}
          >
            {cell.render('Cell')}
          </td>
        )
      })}
      <td className='text-center min-w-120px'>
        {isAuthorized && (
          <>
            <TooltipWrapper
              tooltipText={'Editar'}
              tooltipPlacement={'top'}
            >
              <button className="btn btn-link btn-color-muted btn-active-color-danger" onClick={() => handleToEdit()}>
                <i className="ki-duotone ki-pencil me-5 fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              </button>
            </TooltipWrapper>
            <TooltipWrapper
              tooltipText={'Excluir'}
              tooltipPlacement={'top'}
            >
              <button className="btn btn-link btn-color-muted btn-active-color-danger" onClick={() => handleToDelete()}>
                <i className="ki-duotone ki-trash fs-1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                </i>
              </button>
            </TooltipWrapper>
          </>
        )}
      </td>
    </tr>
  )
}

export { CustomRow }
